module.exports = __webpack_public_path__ + "img/table-expand.9b164224.svg";